import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Outlet, useOutletContext } from 'react-router-dom'

import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'

import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'
import { useFetcher } from '@lyrahealth-inc/ui-core-crossplatform/src/hooks/useFetcher'
import { useMediaQuerySize } from '@lyrahealth-inc/ui-core-crossplatform/src/hooks/useMediaQuerySize'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { CLIENT_NEW_NOTE, CLIENT_NOTE } from '../../common/constants/routingConstants'
import { getICD10s } from '../../data/healthPlanAutoActions'
import { useAllBannerVisibility } from '../../hooks/useAllBannerVisibility'
import { useVideoSessionBannerHeight } from '../../hooks/useVideoSessionBannerHeight'
import { useSelectedEpisodeForClient } from '../episodes/data/hooks/useSelectedEpisodeForClient'

const NOTIFICATION_BANNER_HEIGHT = 90

export function ClientNotesRoutes({ actions: { getICD10s } }: any) {
  const { data: clientDetailsSelectedEpisode } = useSelectedEpisodeForClient() as { data: Episode | undefined }
  const [selectedEpisode, setSelectedNotesEpisode] = useState(clientDetailsSelectedEpisode)

  const { lastProviderSpecificEpisode } = useOutletContext<{ lastProviderSpecificEpisode: Episode | undefined }>()
  const { hasAnyBanner } = useAllBannerVisibility()
  const videoSessionBannerHeight = useVideoSessionBannerHeight()

  useEffect(() => {
    if (clientDetailsSelectedEpisode) {
      setSelectedNotesEpisode(clientDetailsSelectedEpisode)
    }
  }, [setSelectedNotesEpisode, clientDetailsSelectedEpisode])

  useFetcher([[getICD10s]])

  const contentHasInternalScrollbar =
    location.pathname.startsWith(CLIENT_NEW_NOTE.route) || location.pathname.startsWith(CLIENT_NOTE.route)
  const { isMinWidthLaptop } = useMediaQuerySize()

  return (
    <div
      data-testid={tID('ClientNotes-tab')}
      style={
        contentHasInternalScrollbar && isMinWidthLaptop
          ? {
              height: `calc(100vh - ${hasAnyBanner ? NOTIFICATION_BANNER_HEIGHT : 0}px)`,
              overflowY: 'auto',
              padding: '0px',
              marginTop: videoSessionBannerHeight,
            }
          : {}
      }
    >
      <Outlet context={{ episode: selectedEpisode, lastProviderSpecificEpisode }} />
    </div>
  )
}

ClientNotesRoutes.propTypes = {
  actions: PropTypes.object,
}
const mapDispatchToProps = (dispatch: any) => ({
  actions: bindActionCreators({ getICD10s }, dispatch),
})

export default connect(undefined, mapDispatchToProps)(ClientNotesRoutes)
